import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";

import PermList from "@/lib/helper/PermList";
import {Button, Input, Modal} from "antd";
import {Can} from "@/components/can/Can";
import AdminLayout from "@/components/layout/admin/adminLayout";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import TableSearch from "@/components/table/tableSearch";
import {useApiCreateAdminRole, useApiSearchAdminRoles} from "@/api/roles";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";


export function RolesListPage() {
    const [openModal, setOpenModal] = useState();
    const [roleName, setRoleName] = useState('')
    const [needRefetch, setNeedRefetch] = useState(false)
    const navigate = useNavigate()
    const {mutate: addRole, isPending: isPendingAddRole, isSuccess: isSuccessAddRole} = useApiCreateAdminRole()

    const columns = [
        {
            title: 'عنوان',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div className={`flex gap-2 items-center`}>
                    <div className={`flex flex-col`}>
                        <span>{record['name']}</span>
                        <span className={`text-xs text-gray-7`}>{record['mobile']}</span>
                    </div>
                </div>
            ),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => {
                return convertToJalaliWithFormat(record?.created_at)
            }

        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => (
                <Can permission={PermList.ROLES_EDIT} skeleton={false}>
                    <Link to={sprintf(URLS.admin.roles.edit, {id: record.id})}>
                        <Button size={`small`}>نمایش جزئیات</Button>
                    </Link>


                </Can>

            ),
        },
    ]
    return (
        <AdminLayout pageTitle={'لیست سطوح دسترسی'} backTo={URLS.admin.dashboard}>
            <Can permission={PermList.ROLES_ADD}>
                <Modal title={'ایجاد سطح دسترسی جدید'}
                       open={openModal}
                       onOk={() => {
                           addRole(
                               {name: roleName},
                               {
                                   onSuccess: (res) => {
                                       ApiHandleSuccessMessage(res)
                                       setOpenModal(false)
                                       setRoleName('')
                                       setNeedRefetch(true)
                                   },
                                   onError: (err) => {
                                       ApiHandleErrorMessage(err)
                                   }
                               }
                           )
                       }}
                       onCancel={() => {
                           setOpenModal(false);
                           setRoleName('')
                       }}>
                    <div className="flex flex-col p-3 gap-2">
                        <div className={`flex flex-col gap-1`}>
                            <span className={`font-medium`}>نام سطح دسترسی</span>
                            <Input placeholder={'نام سطح دسترسی'}
                                   value={roleName}
                                   onChange={(e) => setRoleName(e.target.value)}
                            />
                        </div>

                    </div>
                </Modal>
            </Can>
            <div className="flex flex-col gap-4 m-2">
                <TableSearch apiFn={useApiSearchAdminRoles}
                    // fnArgs={{id: id}}
                             searchInput={true}
                             needRefetch={needRefetch}
                             setNeedRefetch={setNeedRefetch}
                             addButton={
                                 <Can permission={PermList.ROLES_ADD}>
                                     <div className={`flex justify-end`}>
                                         <Button onClick={() => {
                                             setOpenModal(true)
                                         }}
                                                 disabled={isPendingAddRole}
                                                 loading={isPendingAddRole}
                                                 type={`primary`}
                                                 icon={<i className={`icon-plus my-1`}/>}>
                                             افزودن
                                         </Button>
                                     </div>

                                 </Can>
                             }
                             columns={columns}>

                </TableSearch>

            </div>
        </AdminLayout>
    )
}
